import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bool, func, number, string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import capitalize from "Utilities/capitalize";

StatusButton.propType = {
  status: string,
  isSelected: bool,
  setSelected: func,
  count: number,
  paymentTypeNoun: string,
};

export default function StatusButton({
  status,
  isSelected,
  setSelected,
  count,
  paymentTypeNoun,
}) {
  const handleClick = (status) => {
    if (isSelected) {
      setSelected(null);
    } else {
      setSelected(status);
    }
  };
  return (
    <Button $isSelected={isSelected} onClick={() => handleClick(status)}>
      <Icon icon={faChevronDown} size="sm" $isSelected={isSelected} />
      <span>{capitalize(status)}</span>
      <Count>
        {count} {paymentTypeNoun}
        {count === 1 ? "" : "s"}
      </Count>
    </Button>
  );
}

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: none;
  font-size: 18px;
  font-weight: 600;
  color: #15436a;
  cursor: pointer;
`;

const Icon = styled(FontAwesomeIcon)`
  transform: ${(props) => `rotate(${props.$isSelected ? "180deg" : 0})`};
  transition: transform ease-in-out 0.2s;
`;

const Count = styled.span`
  font-size: 12px;
  font-weight: 300;
  color: grey;
`;
